module.exports = __webpack_public_path__ + "static/media/sun.036546b8.png";